import { useTheme } from "@mui/material"

export default function DirectionIcon({size = 40}) {
  const theme = useTheme();

  const baseWidth = 44;
  const baseHeight = 56;

  const height = (baseHeight * size) / baseWidth;

  return (
    <svg 
      width={baseWidth}
      height={height} 
      viewBox="0 0 44 56" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M30.5714 7.69806H39.1429C39.9006 7.69806 40.6273 7.99823 41.1632 8.53255C41.699 9.06686 42 9.79154 42 10.5472V50.4347C42 51.1904 41.699 51.9151 41.1632 52.4494C40.6273 52.9837 39.9006 53.2839 39.1429 53.2839H4.85714C4.09938 53.2839 3.37266 52.9837 2.83684 52.4494C2.30102 51.9151 2 51.1904 2 50.4347V10.5472C2 9.79154 2.30102 9.06686 2.83684 8.53255C3.37266 7.99823 4.09938 7.69806 4.85714 7.69806H13.4286" 
        stroke={theme.palette.rgd.primary} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M21.9997 39.0385V27.642M27.7139 33.3402H16.2854M30.5711 4.84911C30.5711 4.09348 30.2701 3.3688 29.7342 2.83449C29.1984 2.30017 28.4717 2 27.7139 2H16.2854C15.5276 2 14.8009 2.30017 14.2651 2.83449C13.7292 3.3688 13.4282 4.09348 13.4282 4.84911V13.3964H30.5711V4.84911Z" 
        stroke={theme.palette.rgd.primary} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"/>
    </svg>
  )
}